/**
 * Structured classification of a non-scheduling clinic call. Produced by the NotifyMD
 * extraction and by the voice agent (sent in the telephone-encounter API request), and
 * used to route the encounter to the right ECW staff inbox per tenant.
 */
export enum ClinicCallReason {
  ALLERGY_RELATED = "Allergy Related",
  APPOINTMENT_INQUIRY = "Appointment Inquiry",
  BILLING_QUESTION = "Billing Question",
  CANCEL_APPOINTMENT = "Cancel Appointment",
  CLINICAL_QUESTION = "Clinical Question",
  DME_INQUIRY = "DME Inquiry",
  INSURANCE_ELIGIBILITY = "Insurance Eligibility",
  MEDICATION_RELATED = "Medication Related",
  REFERRAL_QUESTION = "Referral Question",
  RESCHEDULE_APPOINTMENT = "Reschedule Appointment",
  RESULTS_INQUIRY = "Results Inquiry",
  SCHEDULE_APPOINTMENT = "Schedule Appointment",
  SLEEP_APPOINTMENT = "Sleep Appointment",
  SLEEP_STUDY_INQUIRY = "Sleep Study Inquiry",
  OTHER = "Other",
}
